import { Injectable } from '@angular/core';
import { ProviderAppointmentMode, ProviderAppointmentType } from '@models';

@Injectable({
  providedIn: 'root',
})
export class AppointmentTypeDisplayService {
  displayAppointmentTypeFn(
    appointmentTypeId: string,
    appointmentTypesMap: Map<string, ProviderAppointmentType>
  ): string {
    if (!appointmentTypeId) {
      console.error('Appointment type id not provided');
      return '';
    }

    if (!appointmentTypesMap.has(appointmentTypeId)) {
      console.error('Could not find appointment type by id');
      return '';
    }

    const appointmentType = appointmentTypesMap.get(appointmentTypeId)!;

    const englishTranslation = appointmentType.translations.find(
      translation => translation.language === 'en'
    );

    if (!englishTranslation) {
      console.error(
        'Could not find english translation for selected appointment type'
      );

      return '-';
    }

    return `${englishTranslation.name} (${this.displayAppointmentTypeModeFn(
      appointmentType.mode
    )})`;
  }

  displayAppointmentTypeModeFn(
    appointmentTypeMode: ProviderAppointmentMode
  ): string {
    switch (appointmentTypeMode) {
      case ProviderAppointmentMode.InPerson:
        return 'In-Person';
      case ProviderAppointmentMode.Virtual:
        return 'Virtual';
      default:
        return '';
    }
  }
}
